import { useState, useEffect } from "react";
import { MessageSquare, Loader2, RefreshCw, Mail, Clock, CheckCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminFeedback({ onClose }) {
  const [feedback, setFeedback] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadFeedback = () => {
    setLoading(true);
    setError(null);
    api.getFeedbackList()
      .then(data => setFeedback(data.feedback || []))
      .catch(() => setError("Erro ao carregar feedback"))
      .finally(() => setLoading(false));
  };

  useEffect(() => { loadFeedback(); }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleDateString("pt-PT", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit"
    });
  };

  return (
    <div className="bg-surface border border-line rounded-sm overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-line bg-surface-hover">
        <div className="flex items-center gap-2">
          <MessageSquare className="w-4 h-4 text-volt" />
          <h3 className="font-heading text-sm font-bold uppercase tracking-widest">Feedback & Sugestões</h3>
          {feedback.length > 0 && (
            <span className="bg-volt/20 text-volt text-[10px] font-bold px-2 py-0.5 rounded-sm">
              {feedback.length}
            </span>
          )}
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={loadFeedback}
            className="p-1.5 hover:bg-surface rounded-sm transition-colors"
            title="Atualizar"
          >
            <RefreshCw className="w-3.5 h-3.5 text-txt-secondary" />
          </button>
          {onClose && (
            <button onClick={onClose} className="text-txt-secondary hover:text-white text-xs px-2 py-1 hover:bg-surface rounded-sm transition-colors">
              ✕
            </button>
          )}
        </div>
      </div>

      {/* Content */}
      {loading ? (
        <div className="flex items-center justify-center py-12">
          <Loader2 className="w-6 h-6 text-volt animate-spin" />
        </div>
      ) : error ? (
        <p className="text-danger text-sm text-center py-8">{error}</p>
      ) : feedback.length === 0 ? (
        <div className="text-center py-12">
          <MessageSquare className="w-8 h-8 text-txt-secondary mx-auto mb-3" />
          <p className="text-txt-secondary text-sm">Sem feedback ainda</p>
        </div>
      ) : (
        <div className="divide-y divide-line/30">
          {feedback.map((item, i) => (
            <div key={i} className="px-4 py-4 hover:bg-surface-hover transition-colors">
              <div className="flex items-start justify-between gap-3 mb-2">
                <div className="flex items-center gap-2">
                  <div className="w-7 h-7 rounded-full bg-volt/10 border border-volt/20 flex items-center justify-center shrink-0">
                    <span className="text-volt text-xs font-bold">
                      {item.user_email ? item.user_email[0].toUpperCase() : "?"}
                    </span>
                  </div>
                  <div>
                    {item.user_email ? (
                      <div className="flex items-center gap-1">
                        <Mail className="w-3 h-3 text-txt-secondary" />
                        <span className="text-xs text-txt-secondary">{item.user_email}</span>
                      </div>
                    ) : (
                      <span className="text-xs text-txt-secondary">Anónimo</span>
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <span className={`text-[10px] font-bold px-2 py-0.5 rounded-sm ${
                    item.status === "new"
                      ? "bg-volt/10 text-volt"
                      : "bg-txt-secondary/10 text-txt-secondary"
                  }`}>
                    {item.status === "new" ? "Novo" : "Visto"}
                  </span>
                </div>
              </div>
              <p className="text-sm text-white leading-relaxed mb-2">{item.message}</p>
              <div className="flex items-center gap-1 text-txt-secondary">
                <Clock className="w-3 h-3" />
                <span className="text-[10px]">{formatDate(item.created_at)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
